// Module
var code = "<a class=\"subFormControl toggle-favourites transition\" data-bind=\"style: _style\"> <i class=\"fa fa-star transition\"></i> </a>";
// Exports
export default code;